var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"home-bed"},[_c('div',{staticClass:"img-bed"},[_c('black-bar',{attrs:{"title":"部分适配机型"}})],1),_c('p',{staticClass:"title"},[_vm._v("武汉通SIM交通卡目前只适用于支持NFC功能的安卓手机，苹果手机不支持使用。部分支持的手机机型有：")]),_c('img',{attrs:{"src":require("../assets/img/noAccess/img_list@2x.png"),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }